import { render, staticRenderFns } from "./PredictionInfoCard.vue?vue&type=template&id=b1c113d2&scoped=true"
import script from "./PredictionInfoCard.vue?vue&type=script&lang=js"
export * from "./PredictionInfoCard.vue?vue&type=script&lang=js"
import style0 from "./PredictionInfoCard.vue?vue&type=style&index=0&id=b1c113d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c113d2",
  null
  
)

export default component.exports